import MasterSubTasks from './masterSubTasksContainer';

export default MasterSubTasks;
